module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "modify-phone"
  }, [_c('steps', {
    attrs: {
      "title": _vm.stepTitle,
      "step": _vm.currentStep
    }
  }), _vm._v(" "), _c(_vm.modify_view, {
    tag: "div",
    attrs: {
      "v_type": _vm.vType,
      "switch_enabled": true,
      "btn_text": _vm.btnText,
      "request": _vm.request,
      "finish_title": _vm.finish_title,
      "modify_type": _vm.stepTitle
    },
    on: {
      "switchValidate": _vm.switchValidate,
      "next": _vm.next,
      "finish": _vm.finish,
      "errorResult": _vm.errorResult
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-317fc8b4!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/validation/phone/modify_phone.vue
// module id = m5UY
// module chunks = 15